define('modules/Product/DynamicProductPrice',[
    'jquery',
    'global/all',
    './ProductPricingService',
    './ProductUnitsOfMeasureHelper',
    'modules/Store/StorePermissionService'
],
    function ($, Roc, ProductPricingService, ProductUnitsOfMeasureHelper, StorePermissionService) {
        'use strict';
        var recaptchaKey = "";
        var isFinalSaleProduct = false;
        var orderItemProductId;
        var simpleProduct;
        var selectors = {
            'qty': '#purchaseQuantity',
            'uom': '#selectedUom',
            'requiredMinimum': '#minimumRequiredlength',
            'pricingWrapper': '[data-roc-binding="pricing"]',
            'customTotalPriceWrapper': null, // by default total price is displayed in the same wrapper, but this is configuration in init method by providing selector in options.customTotalPriceWrapper
            'getPricing': '#getProductPrice',
            'checkStock': '#checkStockButton',
            'btnDistributor': '#btnDistributor',
            'distributorWrapper': '#distributor-form',
            'btnFindDistributor': '#btnFindDistributor',
            'updateZipCode': '#updateZipCode',
            'btnBackDistributor': '#btnBackDistributor'
        };

        function clearPricing() {
            if (selectors.customTotalPriceWrapper !== null) {
                $(selectors.customTotalPriceWrapper).empty();
            }
            $(selectors.pricingWrapper).empty();
        }

        function renderErrorMsg(message) {
            Roc.UI.template('dynamicProductPriceErrors-Tmp', message).then(function (renderedTemplate) {
                clearPricing();
                $(selectors.pricingWrapper).html(renderedTemplate);
            });
        }

        function render(data, inStockMessage) {
            var renderTotalPriceInSeparateView = selectors.customTotalPriceWrapper !== null;
            if (data) {
                _.extend(data,
                    {
                        isFinalSaleProduct: isFinalSaleProduct,
                        skipTotalPriceDisplay: renderTotalPriceInSeparateView
                    });
            }
            var canSeePricing = StorePermissionService.canSeePricing();
            if (canSeePricing && data.price > 0) {
                Roc.UI.template('productPricingDetails-Tmp', data).then(function (renderedTemplate) {
                    $(selectors.pricingWrapper).html(renderedTemplate);

                    if (renderTotalPriceInSeparateView) {
                        // render total price in a separate view
                        Roc.UI.template('productTotalPrice-Tmp', data).then(function (renderedTemplate) {
                            $(selectors.customTotalPriceWrapper).html(renderedTemplate);
                        });
                    }
                });
            }
            else {
                if (!inStockMessage) {
                    renderErrorMsg("Please finalize your quote and submit your request. We will contact you shortly with the best pricing and availability.");
                }
            }
        }

        function getQty() {
            var quantity = null;
            var $qty = $(selectors.qty);
            if ($qty.length > 0) {
                quantity = $qty.val();
            }

            // parse value
            return !quantity || isNaN(quantity) ? -1 : parseInt(quantity);
        }

        function isQtyValid(quantity) {
            return !isNaN(quantity) && quantity > 0;
        }

        function getUom() {
            var $uom = $(selectors.uom);
            var uom = ProductUnitsOfMeasureHelper.getUomIdFromTextBox($uom);
            return uom;
        }

        function isUomValid(uom) {
            return uom !== null;
        }

        function reloadPricing(qty, uom, onLoad) {
            try {
                $("#inStockLabel").html('');
                // need to know if pricing is reloaded on the page load automatically
                // because jQuery event needs to be triggered manually to display product price in this case
                if (onLoad === undefined || onLoad === null) {
                    onLoad = false;
                }

                var productId = $('#hdnProductId').val();
                //if (!productId) {
                //    var msg = 'Please make sure all options are properly selected before trying again.';

                //    throw {
                //        msg: msg,
                //        title: 'Warning!'
                //    };
                //}

                var requiredMinimum = $(selectors.requiredMinimum).data('requiredmin');
                if (requiredMinimum) {
                    var uomQty = isNaN(parseFloat(uom)) ? 1 : parseInt(uom);
                    if (parseInt(requiredMinimum) > (uomQty * qty)) {
                        $(selectors.requiredMinimum).show();
                        clearPricing(); // clear pricing on the front-end
                        return;
                    } else {
                        $(selectors.requiredMinimum).hide();
                    }
                }

                Roc.UI.block(selectors.pricingWrapper);

                var newPricing = null;
                var inStockMessage = null;
                ProductPricingService.getPricing(productId, qty, uom)
                    .then(function (pricingResponse) {
                        if (pricingResponse &&
                            pricingResponse.responseCode === 'Success' &&
                            pricingResponse.items !== undefined &&
                            pricingResponse.items !== null &&
                            pricingResponse.items.length > 0) {
                            newPricing = pricingResponse.items[0].result;
                            if (pricingResponse.items[0].result && pricingResponse.items[0].result.customFields && pricingResponse.items[0].result.customFields["inStockResponse"]) {
                                $("#inStockLabel").show();
                                inStockMessage = pricingResponse.items[0].result.customFields["inStockResponse"];
                                $("#inStockLabel").html(inStockMessage);
                            }
                        }
                    }).always(function () {
                        render(newPricing, inStockMessage);
                        Roc.UI.unblock(selectors.pricingWrapper);
                    });
            } catch (error) {
                if (error.msg) {
                    renderErrorMsg(error.msg);
                }
            }
        }
        function validateQty() {
            var newQty = $(selectors.qty).val();
            if (newQty === '') {
                clearPricing(); // clear pricing on the front-end
                return false;
            }

            if (!isQtyValid(newQty)) {
                //renderErrorMsg('The quantity provided is invalid. Please enter a value greater than 0 and try again.');
                return false;
            }

            validateAfterSelectionOrQtyChange();
            return true;
        }
        function qtyChangeEvt() {
            Roc.UI.siteBody
                .off('change', selectors.qty)
                .on('change', selectors.qty, function () {
                    validateQty();
                    //reloadPricing(newQty, currentUom);
                });
        }

        function validateUom() {
            var $this = $(selectors.uom);
            if ($this.val() === '') {
                clearPricing(); // clear pricing on the front-end
                return false;
            }

            var newUom = ProductUnitsOfMeasureHelper.getUomIdFromTextBox($this);

            if (!isUomValid(newUom)) {
                // renderErrorMsg('The length provided is invalid. Please enter a correct value and try again.');
                return false;
            }

            validateAfterSelectionOrQtyChange();
            return true;
        }
        function uomChangeEvt() {
            Roc.UI.siteBody
                .off('change', selectors.uom)
                .on('change', selectors.uom, function () {
                    validateUom();
                    //reloadPricing(currentQty, newUom);
                });
        }

        function updateMinimumRequiredMinimumOrderLength(viewModel) {
            if (viewModel.productType === 'Simple') {
                var minOrderQty = Roc.Extensions.getAttributeValue(viewModel.customFields, 'minOrderQuantity');
                var minOrderLength = Roc.Extensions.getAttributeValue(viewModel.customFields, 'minOrderLength');
                var content;
                if (viewModel.availableUnitsOfMeasure &&
                    viewModel.availableUnitsOfMeasure.length > 0 &&
                    ProductUnitsOfMeasureHelper.isUnitOfLength(viewModel.availableUnitsOfMeasure[0])) {
                    if (minOrderLength > 1) {
                        $(selectors.requiredMinimum).attr("data-requiredMin", minOrderLength);
                        content = 'Please enter a minimum total Length of ' +
                            minOrderLength +
                            ' ' +
                            viewModel.availableUnitsOfMeasure[0].name;
                    }
                } else {
                    if (minOrderQty > 1) {
                        $(selectors.requiredMinimum).attr("data-requiredMin", minOrderQty);
                        content = 'Please enter a minimum quantity of ' + minOrderQty;
                    }
                }

                if (content) {
                    $(selectors.requiredMinimum).html(content);
                } else {
                    $(selectors.requiredMinimum).empty();
                }
            } else {
                $(selectors.requiredMinimum).empty();
            }
        }

        function validateAfterSelectionOrQtyChange() {
            clearPricing();
            var canSeePricing = StorePermissionService.canSeePricing();
            if (canSeePricing) {
                if ($("#getProductPrice").length) {
                    $("#getProductPrice").show();
                    $("#addToCartBtn").hide();
                }
            }
            else {
                $("#getProductPrice").hide();
                $("#addToCartBtn").show();
                $("#checkStockButton").show();
                $("#addToQuoteBtn").hide();
            }
            $("#inStockLabel").hide();
            $("#inStockLabel").html("");
        }

        function selectionsUpdateEvt() {
            Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, function (productViewModel) {
                clearPricing();
                updateMinimumRequiredMinimumOrderLength(productViewModel);
                //Code has been moved from ProductPrice.js
                $('*[data-element-type="productTitle"]').html(productViewModel.name);

                if (productViewModel.productType === 'Simple') {
                    simpleProduct = productViewModel;
                    $('.itemSku').html('Part #: <span itemprop="sku">' + productViewModel.sku + '</span>');
                } else {
                    $('.itemSku').empty();
                }
                //End of Code copied from ProductPrice.js

                //Change for Ticket #211868
                //$(selectors.qty).val(''); no need to wipe the Qty field
                //CUSTOMIZATION: 213995 : clear quantity values when user change the selection.
                // do not wipe val if order item is loaded
                if (productViewModel.id !== orderItemProductId) {
                    $(selectors.uom).val("");
                }
                var canSeePricing = StorePermissionService.canSeePricing();
                if (canSeePricing) {
                    $("#getProductPrice").show();
                    $("#addToCartBtn").hide();
                }
                else {
                    $("#getProductPrice").hide();
                    $("#addToCartBtn").show();
                    $("#checkStockButton").show();
                    $("#addToQuoteBtn").hide();
                }
                $("#inStockLabel").hide();
                $("#inStockLabel").html("");
            });
        }
        function getPricingEvt() {
            Roc.UI.siteBody
                .off('click', selectors.getPricing)
                .on('click', selectors.getPricing, function () {
                    var productId = $('#hdnProductId').val();
                    if (validateQty() && validateUom() && productId) {
                        reloadPricing($(selectors.qty).val(), getUom());
                        $("#getProductPrice").hide();
                        $("#addToCartBtn").show();
                    }
                    else {
                        var msg = 'Please make sure all options are selected and quantity and length is correct.';
                        Roc.UI.displayErrorPopup(msg, 'Oh no!');
                        return false;
                    }

                });
        }
        function checkStockEvt() {
            Roc.UI.siteBody
                .off('click', selectors.checkStock)
                .on('click', selectors.checkStock, function () {
                    var productId = $('#hdnProductId').val();
                    if (validateQty() && validateUom() && productId) {
                        reloadPricing($(selectors.qty).val(), getUom());
                        $("#checkStockButton").hide();
                        $("#addToQuoteBtn").show();
                    }
                    else {
                        var msg = 'Please make sure all options are selected and quantity and length is correct.';
                        Roc.UI.displayErrorPopup(msg, 'Oh no!');
                        return false;
                    }

                });
        }

        function distributorEvt() {
            Roc.UI.siteBody
                .off('click', selectors.btnDistributor)
                .on('click', selectors.btnDistributor, function () {
                    var productId = $('#hdnProductId').val();
                    if (validateQty() && validateUom() && productId) {
                        $('#distributor-form').show();
                        Roc.UI.Modal.open('#distributor-form');
                        // Select the button element by its class
                        var closeButton = document.querySelector('.mfp-close');

                        // Set the text color to black
                        if (closeButton) {
                            closeButton.style.color = 'black';
                        } else {
                            console.log('Button not found!');
                        }
                    }
                    else {
                        var msg = 'Please make sure all options are selected and quantity and length is correct.';
                        Roc.UI.displayErrorPopup(msg, 'Oh no!');
                        return false;
                    }

                });

            Roc.UI.siteBody
                .off('click', selectors.btnBackDistributor)
                .on('click', selectors.btnBackDistributor, function () {
                    var closeButton = document.querySelector('.mfp-close');

                    if (closeButton) {
                        closeButton.click();
                        return false;
                    } else {
                        console.log('Button not found!');
                    }
                });


        }

        function validateUSorCanadaZipCode(zip) {
            var regex = /^(\d{5}(-\d{4})?)$|^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
            return regex.test(zip);
        }

        function contactDistributorEvt() {
            Roc.UI.siteBody
                .off('click', '#btnContactDistributor')
                .on('click', '#btnContactDistributor', function () {
                   
                    if (simpleProduct && simpleProduct.selectionValues) {
                                  // Get form values
                        var name = document.getElementById('distributorName').value.trim();
                        var email = document.getElementById('distributorEmail').value.trim();
                        var phone = document.getElementById('distributorPhone').value.trim();
                        var company = document.getElementById('distributorCompany').value.trim();
                        var notes = document.getElementById('txtNotes').value.trim();
                        // Error message container
                        var errorMessages = [];

                        // Name Validation
                        if (!name.match(/^[A-Za-z\s'-.#@]{2,}$/)) { // Allows letters and spaces, minimum 2 characters
                            errorMessages.push("Please enter a valid name with at least 2 characters.");
                        }

                        // Email Validation
                        if (!email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) { // Basic email format check
                            errorMessages.push("Please enter a valid email address.");
                        }

                        // Phone Validation (US and Canada format, 10 digits)
                        if (!phone.match(/^\d{10}$/)) {
                            errorMessages.push("Please enter a valid 10-digit phone number.");
                        }
                        if (errorMessages.length > 0) {
                            Roc.UI.displayErrorPopup(errorMessages.join(". "));
                            return false;
                        }
                        grecaptcha.ready(function () {
                            grecaptcha.execute(recaptchaKey, { action: 'submit' }).then(function (token) {
                                var requestData = {};
                                requestData.token = token;
                                $.ajax({
                                    url: '/ajax/VerifyReCaptchaToken',
                                    type: 'POST',
                                    contentType: 'application/json',
                                    dataType: 'json',
                                    data: JSON.stringify(requestData),
                                    complete: function (xhr) {
                                        var response = xhr.responseJSON || {};
                                        if (response && response.success === true) {
                                            var request = {};
                                            request.name = name;
                                            request.email = email;
                                            request.phone = phone;
                                            request.company = company;
                                            request.notes = notes;
                                            var selectedRadio = document.querySelector('#DistributorList input[type="radio"]:checked');
                                            if (selectedRadio) {
                                                request.organization = selectedRadio.value;
                                            }
                                            else {
                                                request.organization = $('#hdnOrg').val();
                                            }
                                            request.qty = $(selectors.qty).val();
                                            request.uom = getUom();
                                            request.productId = $('#hdnProductId').val();
                                            return $.proxyRequest({
                                                url: '/api/quote/contactdistributor',
                                                type: 'POST',
                                                dataType: 'json',
                                                contentType: 'application/json; charset=utf-8',
                                                data: JSON.stringify(request)
                                            }).always(function () {
                                                Roc.UI.displayErrorPopup("Your request has been submitted. You will receive an email confirming your request. The distributor of your choice will reach out to you.", "Thank you!");
                                                var divElement = document.getElementById('confirmButtons');

                                                // Assign text-align: left;
                                                divElement.style.textAlign = 'left';
                                            });
                                        }
                                        else {
                                            Roc.UI.displayErrorPopup('There was an error processing your request, please try again.');
                                        }
                                    }
                                });
                            });
                        });
                        
                    }


                });
            Roc.UI.siteBody
                .off('click', '#btnReset')
                .on('click', '#btnReset', function () {
                    $('#dvContact').hide();
                    $("#dvSearch").show();
                    $("#dvSearchResults").hide();
                });


        }
        function distributorZipUpdateEvt() {
            Roc.UI.siteBody
                .off('click', selectors.updateZipCode)
                .on('click', selectors.updateZipCode, function () {
                                    var productId = $('#hdnProductId').val();
                    if (validateQty() && validateUom() && productId) {
                        if (validateUSorCanadaZipCode($('#distributorZipCode').val()) === false) {
                            Roc.UI.displayErrorPopup("Please enter a valid zip code.");
                            return false;
                        }
                        searchDistributors($('#distributorZipCode').val()).then(function (quoteDetails) {
                            Roc.UI.block();
                           // $('#distributorZipCode').val($('#distributorZip').val());
                            var listContainer = document.getElementById("DistributorList");
                            listContainer.innerHTML = '';
                            while (listContainer.firstChild) {
                                listContainer.removeChild(listContainer.firstChild); // Remove each child until there are none left
                            }
                            // Loop through each item in the array
                            quoteDetails.forEach(function (item, index) {
                                // Create a div element to hold the radio button and label
                                var radioContainer = document.createElement("div");

                                // Create a radio input element
                                var radioInput = document.createElement("input");
                                radioInput.type = "radio";
                                radioInput.name = "quoteOptions"; // Group all radio buttons
                                radioInput.id = "quoteOption" + index; // Unique id for each radio button
                                radioInput.value = item;
                                var splitData = item.split('^^^^');
                                // Create a label for the radio button
                                var label = document.createElement("label");
                                label.htmlFor = radioInput.id;
                                var formattedText = splitData.join('<br>');

                                // Assign the formatted text to the label
                                //document.getElementById('radioLabel').innerHTML += formattedText;
                                label.innerHTML = formattedText;
                                label.style = "margin-left: 10px; flex-grow: 1;";



                                // Append the radio input and label to the container
                                radioContainer.appendChild(radioInput);
                                radioContainer.appendChild(label);

                                // Append the button to the container
                                //radioContainer.appendChild(button);

                                // Append the container to the parent container
                                listContainer.appendChild(radioContainer);
                            });
                            $('#divDistributorList').show();

                        })
                            .fail(function () {
                                Roc.UI.displayErrorPopup("Could not retrieve distributor details.");
                            })
                            .always(function () { Roc.UI.unblock(); })
                    }
                    else {
                        var msg = 'Please make sure all options are selected and quantity and length is correct.';
                        Roc.UI.displayErrorPopup(msg, 'Oh no!');
                        return false;
                    }

                });
        }

        function distributorSearchEvt() {
            Roc.UI.siteBody
                .off('click', selectors.btnFindDistributor)
                .on('click', selectors.btnFindDistributor, function () {
                  
                    $('#dvContact').show();
                    $("#dvSearch").hide();
                    $("#dvSearchResults").show();
                    $("#dvSearchResults").addClass('el-active');
                    var productId = $('#hdnProductId').val();
                    if (validateQty() && validateUom() && productId) {
                        if (validateUSorCanadaZipCode($('#distributorZip').val()) === false) {
                            Roc.UI.displayErrorPopup("Please enter a valid zip code.");
                            return false;
                        }
                        searchDistributors($('#distributorZip').val()).then(function (quoteDetails) {
                            Roc.UI.block();
                            $('#distributorZipCode').val($('#distributorZip').val());
                            var listContainer = document.getElementById("DistributorList");
                            while (listContainer.firstChild) {
                                listContainer.removeChild(listContainer.firstChild); // Remove each child until there are none left
                            }

                            // Loop through each item in the array
                            quoteDetails.forEach(function (item, index) {
                                // Create a div element to hold the radio button and label
                                var radioContainer = document.createElement("div");

                                // Create a radio input element
                                var radioInput = document.createElement("input");
                                radioInput.type = "radio";
                                radioInput.name = "quoteOptions"; // Group all radio buttons
                                radioInput.id = "quoteOption" + index; // Unique id for each radio button
                                radioInput.value = item;
                                var splitData = item.split('^^^^');
                                // Create a label for the radio button
                                var label = document.createElement("label");
                                label.htmlFor = radioInput.id;
                                var formattedText = '<strong>'+splitData[0]+'</strong><br>'+splitData.slice(1).join("<br>");

                                // Assign the formatted text to the label
                                //document.getElementById('radioLabel').innerHTML += formattedText;
                                label.innerHTML = formattedText;
                                label.style = "margin-left: 10px; flex-grow: 1;";

                                radioContainer.appendChild(radioInput);
                                radioContainer.appendChild(label);

                                listContainer.appendChild(radioContainer);
                            });
                            $('#divDistributorList').show();
                            if (simpleProduct && simpleProduct.selectionValues) {
                               
                               
                                $('#productname').text(simpleProduct.name);
                                $('#productqty').text($(selectors.qty).val());
                                $('#productlength').text($(selectors.uom).val());
                                $('#productlengthtotal').text($(selectors.qty).val() * $(selectors.uom).val());
                                var defaultAsset = simpleProduct.images.find(function (item) {
                                    return item.isDefault;
                                });

                                // Get the path
                                var defaultPath = defaultAsset ? defaultAsset.asset.path : null;
                                if (defaultPath) {
                                    $('#productimageurl').attr('src', "https://assetcloud.roccommerce.net/" + defaultPath);
                                }

                                var productSelections = document.getElementById('productselections');

                                // Update the <p> content dynamically
                                var updatedContent = '';
                                simpleProduct.selectionValues.forEach(function (item) {
                                    updatedContent += item.attributeName + ': ' + item.option + '<br>';
                                });

                                // Set the updated content to the <p> element
                                productSelections.innerHTML = updatedContent;
                            }
                        })
                            .fail(function () {
                                Roc.UI.displayErrorPopup("Could not retrieve distributor details.");
                            })
                            .always(function () { Roc.UI.unblock(); })
                    }
                    else {
                        var msg = 'Please make sure all options are selected and quantity and length is correct.';
                        Roc.UI.displayErrorPopup(msg, 'Oh no!');
                        return false;
                    }

                });
        }

        function searchDistributors(zip) {
            return $.proxyRequest({
                url: '/api/quote/distributorbyzip/' + zip,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8'
            });
        }
        function bindEvents() {
            qtyChangeEvt();
            uomChangeEvt();
            getPricingEvt();
            selectionsUpdateEvt();
            checkStockEvt();
            distributorEvt();
            distributorSearchEvt();
            contactDistributorEvt();
            distributorZipUpdateEvt();
        }

        function init(options) {
            var displayPricingOnLoad = false;
            if (options && options.recaptchaKey) {
                recaptchaKey = options.recaptchaKey;
            }
            if (options) {
                if (options.orderItemProductId) {
                    orderItemProductId = options.orderItemProductId;
                }

                if (options.isFinalSaleProduct) {
                    isFinalSaleProduct = options.isFinalSaleProduct;
                }

                if (options.displayPricingOnLoad !== undefined && options.displayPricingOnLoad !== null) {
                    displayPricingOnLoad = options.displayPricingOnLoad;
                }

                if (options.predefinedLength) {
                    $(selectors.uom).val(options.predefinedLength);
                }

                if (options.customTotalPriceWrapper) {
                    selectors.customTotalPriceWrapper = options.customTotalPriceWrapper;
                }
            }

            bindEvents();
            if (isFinalSaleProduct || displayPricingOnLoad) {
                // make sure pricing is reloaded when DOM is ready (this is because of some events in SetupOmni module that are handling pricing display)
                $(document).ready(function () {
                    var qty = getQty();
                    var uom = getUom();
                    if (isQtyValid(qty) && isUomValid(uom)) {
                        reloadPricing(qty, uom, true);
                    }
                });
            }
        }

        var DynamicProductPrice = {
            init: init
        };

        Roc.Logger.debug('DynamicProductPrice.js Loaded:', DynamicProductPrice);

        return DynamicProductPrice;
    });
